module.exports = new __parcel__URL__("blossom.90b2a1c3.svg").toString();